/**
 * Brand asset resolution.
 *
 * Resolves the active brand so loaders and marks always come from the
 * right `static/brand/<brand>/` folder.
 */

export type BrandKey = "afriannotate";

export const activeBrand = (): BrandKey => "afriannotate";

/** Path to a named asset in the active brand's folder, e.g. `brandAsset("mark-256.png")`. */
export const brandAsset = (file: string): string => `/static/brand/${activeBrand()}/${file}`;

/**
 * Path to the active brand's animated loader.
 *
 * Defaults to the boxed GIF (universal, e.g. emails). Pass options for the
 * transparent WebP (fits any background) and/or the dark-theme variant:
 *   brandLoaderSrc()                      -> anim.gif        (light, boxed)
 *   brandLoaderSrc({ webp: true })        -> anim.webp       (light, transparent)
 *   brandLoaderSrc({ dark: true })        -> anim-dark.gif   (dark, boxed)
 *   brandLoaderSrc({ webp: true, dark })  -> anim-dark.webp  (dark, transparent)
 */
export const brandLoaderSrc = (opts?: { webp?: boolean; dark?: boolean }): string =>
  brandAsset(`anim${opts?.dark ? "-dark" : ""}.${opts?.webp ? "webp" : "gif"}`);
